import { Button, Empty, Table } from "antd";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { amountFormat } from "../services/common.service";

export default function ScheduledPaymentGrid({
  dataSource,
  setDetails,
  setVisible,
  hasMoreRecords,
  fetchMoreTransactions,
}) {
  const { t } = useTranslation();
  return (
    <>
      <Table
        rowHoverable={false}
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50", "100", "500"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} records`,
        }}
        bordered
        sticky={true}
        onRow={(record) => ({
          className: "table-row-pointer",
          onClick: () => {
            setDetails(record);
            setVisible(true);
          },
        })}
        columns={[
          {
            title: "Scheduled Date",
            align: "left",
            key: "scheduledDate",
            ellipsis: true,
            render: (option) => (
              <>
                <span>
                  {option.scheduledDate
                    ? moment(option.scheduledDate).format("DD-MM-YYYY")
                    : "-"}
                </span>
              </>
            ),
          },
          {
            title: "Biller Name",
            dataIndex: "billerName",
            align: "left",
            key: "billerName",
            ellipsis: true,
          },
          {
            title: "Consumer Id",
            dataIndex: "consumerId",
            key: "consumerId",
            ellipsis: true,
          },
          {
            title: "Mobile Number",
            dataIndex: "mobileNo",
            key: "mobileNo",
            ellipsis: true,
          },
          {
            title: "Amount",
            key: "amount",
            align: "right",
            width: 150,
            render: (option) => (
              <>
                <span>{amountFormat(option.amount, option?.txnCcy)}</span>
              </>
            ),
          },
          {
            title: " Status",
            key: "scheduledStatus",
            width: 150,
            align: "left",
            render: (option) => (
              <>
                {option.scheduledStatus === "P" ? (
                  <span className="pending-status px-2 py-1">
                    {t("pages.pending_approval.pending", {
                      defaultValue: "PENDING",
                    })}
                  </span>
                ) : option.scheduledStatus === "FAIL" ? (
                  <span className="fail-error px-2 py-1">
                    {t("pages.pending_approval.fail", {
                      defaultValue: "FAIL",
                    })}
                  </span>
                ) : option.scheduledStatus === "CANCELLED" ? (
                  <span className="fail-error px-2 py-1">
                    {" "}
                    {t("pages.pending_approval.cancelled", {
                      defaultValue: "CANCELLED",
                    })}
                  </span>
                ) : option.scheduledStatus === "SUCCESS" ? (
                  <span className="success-text px-2 py-1">
                    {option.scheduledStatus}
                  </span>
                ) : option.scheduledStatus === null ? (
                  "-"
                ) : (
                  <span className="success-text px-2 py-1">
                    {option.scheduledStatus}
                  </span>
                )}
              </>
            ),
          },
        ]}
      />
    </>
  );
}
